import { Component, Input } from '@angular/core';

// ButtonComponent is a regular Angular component (not standalone)
// It should be declared in SharedModule
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false
})
export class ButtonComponent {
  @Input() variant: 'primary' | 'secondary' | 'outline' = 'primary';
  @Input() size: 'lg' | 'sm' | '' = '';
  @Input() icon = false;
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' = 'button';

  get classes() {
    return {
      btn: true,
      'btn-primary': this.variant === 'primary',
      'btn-secondary': this.variant === 'secondary',
      'btn-outline': this.variant === 'outline',
      'btn-lg': this.size === 'lg',
      'btn-sm': this.size === 'sm',
      'btn-icon': this.icon
    };
  }

  onClick(event: Event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
